import React, { useEffect, useState } from 'react';
import logo from '../../../public/assets/images/logo.jpeg';

const Preloader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div id="preloader" className="preloader">
      <div className="preloader-inner">
        <img style={{ height: '150px', width: '200px', padding: '10px' }} src={logo} alt="Legend Safaris" />
      </div>
      <div id="loader" className="th-preloader" style={{ marginTop: '100px' }}>
        <div className="animation-preloader">
          <div className="txt-loading">
            <span preloader-text="L" className="characters">L </span>
            <span preloader-text="E" className="characters">E </span>
            <span preloader-text="G" className="characters">G </span>
            <span preloader-text="E" className="characters">E </span>
            <span preloader-text="N" className="characters">N </span>
            <span preloader-text="D" className="characters">D </span>
            <br />
            <span preloader-text="S" className="characters">S </span>
            <span preloader-text="A" className="characters">A </span>
            <span preloader-text="F" className="characters">F </span>
            <span preloader-text="A" className="characters">A </span>
            <span preloader-text="R" className="characters">R </span>
            <span preloader-text="I" className="characters">I </span>
            <span preloader-text="S" className="characters">S </span>
            <br />
            <span preloader-text="N" className="characters">N </span>
            <span preloader-text="A" className="characters">A </span>
            <span preloader-text="M" className="characters">M </span>
            <span preloader-text="I" className="characters">I </span>
            <span preloader-text="B" className="characters">B </span>
            <span preloader-text="I" className="characters">I </span>
            <span preloader-text="A" className="characters">A </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;